export const toFixed = (value, fixed = 2) => {
  const float = parseFloat(value);
  if (!isNaN(float)) {
    return float.toFixed(fixed);
  }
  return "";
};
